import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class XP55AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleCabinChange = this.handleCabinChange.bind(this);
        this.handleShelvingChange = this.handleShelvingChange.bind(this);
        this.handleSeaBerthChange = this.handleSeaBerthChange.bind(this);
    }
    
    handleCabinChange(event) {
        let configuration = this.props.configuration;

        if (event.target.checked) {
            configuration.BerthInfill = { value: 2, label: 'true' };
        } else {
            configuration.BerthInfill = { value: 1, label: 'false' };
        }

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }
    
    handleShelvingChange(event) {
        let configuration = this.props.configuration;

        if (event.target.checked) {
            configuration.AftCabinShelving = { value: 2, label: 'true' };
            configuration.SeaBerths = { value: 1, label: 'false' };
        } else {
            configuration.AftCabinShelving = { value: 1, label: 'false' };
        }
        
        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleSeaBerthChange(event) {
        let configuration = this.props.configuration;

        if (event.target.checked) {
            configuration.SeaBerths = { value: 2, label: 'true' };
            configuration.AftCabinShelving = { value: 1, label: 'false' };
        } else {
            configuration.SeaBerths = { value: 1, label: 'false' };
        }

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="XP55" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='Standard of the Xp 55 is double berth in both aft cabins.' /></p>
                    <p><Trans defaults='Optional is a split berth in port side aft cabin and freeboard hung sea berths in both cabins. Please, note that sea berths are not an option if upper cupboards are selected.' /></p>
                    <p><Trans defaults='For extra storage, upper cupboards in both aft cabins is an option.' /></p>
                    
                    <Toggle checked={this.props.configuration.BerthInfill.value === 2} onChange={this.handleCabinChange}>
                        <Trans defaults='Show double berth' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.AftCabinShelving.value === 2} onChange={this.handleShelvingChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.SeaBerths.value === 2} onChange={this.handleSeaBerthChange}>
                        <Trans defaults='Sea berths' />
                    </Toggle>
                    
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55AftCabin);


// WEBPACK FOOTER //
// ./src/XP55/XP55AftCabin.js